export interface PendingPurchase {
  productId: string;
  seatTier: string;
  pricingTier: string;
}

const pendingByParent = new Map<string, PendingPurchase>();
const listeners = new Set<() => void>();

export function getPendingPurchase(parentId: string): PendingPurchase | null {
  return pendingByParent.get(parentId) ?? null;
}

export function rememberPendingPurchase(parentId: string, pending: PendingPurchase): void {
  pendingByParent.set(parentId, pending);
  listeners.forEach((listener) => listener());
}

export function clearPendingPurchase(parentId: string): void {
  pendingByParent.delete(parentId);
  listeners.forEach((listener) => listener());
}

export function subscribePendingPurchase(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
